import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  Collapse,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  Grid,
  TextField,
  InputAdornment,
  DialogActions,
  Alert,
  CardActions,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetDeliveryProfileDetailMutation,
  useGetDeliveryProfileDataMutation,
  useGetDeliveryProfileItemsMutation,
  useGetDeliveryProfileLocationMutation,
  useGetCountriesQuery,
  useUpdateDeliveryProfileMutation,
  useDeleteDeliveryProfileMutation,
} from "../../../redux/reducer/features/Shipping/shippingSlice";
import { Country, Province } from "../../../models/features/Shipping/Shipping";
import PageLoader from "../../app/PageLoader";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LanguageIcon from "@mui/icons-material/Language";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";
import AppGrid from "../../app/AppGrid";
import ImageIcon from "@mui/icons-material/Image";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import ShippingProducts from "./ShippingProducts";
import ManageShippingProducts from "./ManageShippingProducts";

const carriers = [
  {
    id: 65075675351,
    name: "dhl_express",
    active: true,
    service_discovery: true,
    carrier_service_type: "legacy",
    admin_graphql_api_id: "gid://shopify/DeliveryCarrierService/65075675351",
  },
  {
    id: 65075708119,
    name: "ups_shipping",
    active: true,
    service_discovery: true,
    carrier_service_type: "legacy",
    admin_graphql_api_id: "gid://shopify/DeliveryCarrierService/65075708119",
  },
  {
    id: 65075642583,
    name: "usps",
    active: true,
    service_discovery: true,
    carrier_service_type: "legacy",
    admin_graphql_api_id: "gid://shopify/DeliveryCarrierService/65075642583",
  },
];
const DHLServices = [
  {
    service: "Worldwide",
    isSelected: false,
  },
];
const UPSServices = [
  {
    service: "UPS 2nd Day Air A.M.® (commercial addresses only)",
    isSelected: false,
  },
  { service: "UPS 2nd Day Air®", isSelected: false },
  { service: "UPS 3 Day Select®", isSelected: false },
  { service: "UPS Next Day Air Saver®", isSelected: false },
  { service: "UPS Next Day Air®", isSelected: false },
  { service: "UPS Next Day Air® Early", isSelected: false },
  { service: "UPS Worldwide Expedited®", isSelected: false },
  { service: "UPS Worldwide Express Plus®", isSelected: false },
  { service: "UPS Worldwide Express®", isSelected: false },
  { service: "UPS Worldwide Saver®", isSelected: false },
  { service: "UPS® Ground", isSelected: false },
  { service: "UPS® Standard", isSelected: false },
];

const USPSServices = [
  {
    service: "First Class Package International",
    isSelected: false,
  },
  { service: "Priority Mail Express International", isSelected: false },
  { service: "Priority Mail International", isSelected: false },
];

const DeliveryProfileDetail: React.FunctionComponent = () => {
  let { id } = useParams();
  const { data, isLoading } = useGetCountriesQuery();
  const [openZone, setOpenZone] = React.useState(false);
  const [zoneName, setZoneName] = React.useState("");
  const [countries, setCountries] = React.useState<Country[]>([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [expanded, setExpanded] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);
  const [openRate, setOpenRate] = React.useState(false);
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [openProducts, setOpenProducts] = React.useState(false);
  const [percentage, setPercentage] = React.useState("0");
  const [selectedZone, setSelectedZone] = React.useState("");
  const [selectedZoneId, setSelectedZoneId] = React.useState("");
  const [zones, setZones] = React.useState<any[]>([]);
  const [onlyRate, setOnlyRate] = React.useState(false);
  const [flatAmount, setFlatAmount] = React.useState("0");
  const [profile, setProfile] = React.useState<any>(null);
  const [products, setProducts] = React.useState<any[]>([]);
  const [selectedProducts, setSelectedProducts] = React.useState<any>([]);
  const [productToDelete, setProductToDelete] = React.useState("");
  const [services, setServices] = React.useState<any[]>([]);
  const [carrier, setCarrier] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [profileLocationGroups, setProfileLocationGroups] =
    React.useState<any>(null);
  const [profileItemGroups, setProfileItemGroups] = React.useState<any>(null);
  const [anchorE, setAnchorE] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorE);

  const openRateTip = Boolean(anchorE2);
  const openZoneTip = Boolean(anchorEl);
  // const [profileDetailMutation, profileDetailMutationResult] =
  //   useGetDeliveryProfileDetailMutation();
  const [profileDataMutation, profileDataMutationResult] =
    useGetDeliveryProfileDataMutation();
  const [profileItemsMutation, profileItemsMutationResult] =
    useGetDeliveryProfileItemsMutation();
  const [profileLocationMutation, profileLocationMutationResult] =
    useGetDeliveryProfileLocationMutation();
  const [updateProfileMutation, updateProfileMutationResult] =
    useUpdateDeliveryProfileMutation();
  const [updateProfileProductsMutation, updateProfileProductsMutationResult] =
    useUpdateDeliveryProfileMutation();
  const [DeleteProfileMutation, DeleteProfileMutationResult] =
    useDeleteDeliveryProfileMutation();

  var navigate = useNavigate();
  const handleClickZone = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickRate = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorE2(event.currentTarget);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRemoveRate = (carrierName: any) => {
    setZones(
      zones.map((item) =>
        item.name === selectedZone
          ? {
              ...item,
              methodDefinitionsToCreate: item.methodDefinitionsToCreate.filter(
                (method: any) => method.name != carrierName
              ),
            }
          : item
      )
    );
  };
  const onCountryClick = (country: Country, index: number) => {
    setCountries(
      countries.map((item) =>
        item.id === country.id
          ? {
              ...item,
              isSelected: !item.isSelected,
              provinces: item.provinces?.map((pro) => ({
                ...pro,
                isSelected: !item.isSelected,
              })),
            }
          : item
      )
    );
  };
  const onServiceClick = (value: any) => {
    setServices(
      services.map((item) =>
        item.service === value
          ? {
              ...item,
              isSelected: !item.isSelected,
            }
          : item
      )
    );
  };

  const onProvinceClick = (province: Province) => {
    setCountries(
      countries.map((item) =>
        item.id === province.countryId
          ? {
              ...item,
              isSelected: province.isSelected ? item.isSelected : true,
              provinces: item.provinces?.map((pro) =>
                pro.id === province.id
                  ? {
                      ...pro,
                      isSelected: !province.isSelected,
                    }
                  : pro
              ),
            }
          : item
      )
    );
  };
  const handleRateSubmit = () => {
    setZones(
      zones.map((item) =>
        item.name === selectedZone
          ? {
              ...item,
              methodDefinitionsToCreate: [
                ...item.methodDefinitionsToCreate,
                {
                  name: carrier,
                  description: null,
                  active: true,
                  participant: {
                    adaptToNewServices: false,
                    carrierServiceId:
                      "gid://shopify/DeliveryCarrierService/" +
                      carriers.find((c) => c.name === carrier)?.id,
                    fixedFee: {
                      amount: flatAmount === "" ? "0" : flatAmount,
                      currencyCode: "USD",
                    },
                    participantServices: services
                      .filter((item) => item.isSelected == true)
                      .map((s) => ({
                        active: true,
                        name: s.service,
                      })),
                    percentageOfRateFee: parseInt(percentage),
                  },
                },
              ],
            }
          : item
      )
    );
    setCarrier("");
    setOpenRate(false);
    setFlatAmount("0");
    setPercentage("0");
  };
  const handleSetCarrier = (value: any) => {
    setCarrier(value);
    if (value === "dhl_express") {
      setServices(DHLServices);
    } else if (value === "usps") {
      setServices(USPSServices);
    } else if (value === "ups_shipping") {
      setServices(UPSServices);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    setAnchorE(null);
    setAnchorE2(null);
    setOpenRate(false);
    setOpenZone(false);
    setErrorMessage("");
    setOnlyRate(false);
    setOpenProducts(false);
    setDeleteConfirm(false);
  };

  const handleDeleteZone = (zoneId: any) => {
    updateProfileMutation({
      data: {
        profile: {
          locationGroupsToUpdate: [
            {
              id: profileLocationGroups[0]?.locationGroup?.id,
            },
          ],
          zonesToDelete: [zoneId],
        },
      },
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };

  const handleDeleteRate = (methodeId: any, zoneId: any) => {
    updateProfileMutation({
      data: {
        profile: {
          locationGroupsToUpdate: [
            {
              id: profileLocationGroups[0]?.locationGroup?.id,
              zonesToUpdate: [
                {
                  id: zoneId,
                  methodDefinitionsToCreate: [],
                  methodDefinitionsToUpdate: [],
                },
              ],
            },
          ],
          methodDefinitionsToDelete: [methodeId],
        },
      },
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };

  const handleUpdateProfile = () => {
    updateProfileMutation({
      data: {
        profile: {
          locationGroupsToUpdate: [
            {
              zonesToCreate: zones,
              id: profileLocationGroups[0]?.locationGroup?.id,
            },
          ],
        },
      },
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };
  const handleUpdateRates = () => {
    updateProfileMutation({
      data: {
        profile: {
          locationGroupsToUpdate: [
            {
              zonesToUpdate: [
                {
                  methodDefinitionsToCreate: [
                    {
                      name: carrier,
                      description: null,
                      active: true,
                      participant: {
                        adaptToNewServices: false,
                        carrierServiceId:
                          "gid://shopify/DeliveryCarrierService/" +
                          carriers.find((c) => c.name === carrier)?.id,
                        fixedFee: {
                          amount: flatAmount === "" ? "0" : flatAmount,
                          currencyCode: "USD",
                        },
                        participantServices: services
                          .filter((item) => item.isSelected == true)
                          .map((s) => ({
                            active: true,
                            name: s.service,
                          })),
                        percentageOfRateFee: parseInt(percentage),
                      },
                    },
                  ],
                  id: selectedZoneId,
                  methodDefinitionsToUpdate: [],
                },
              ],
              id: profileLocationGroups[0]?.locationGroup?.id,
            },
          ],
        },
      },
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };

  const handleAddProducts = () => {
    updateProfileProductsMutation({
      data: {
        profile: {
          variantsToAssociate: selectedProducts.map(
            (prod: any) => "gid://shopify/ProductVariant/" + prod
          ),
        },
      },
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };

  const handleRemoveProducts = (productId: any) => {
    updateProfileProductsMutation({
      data: {
        profile: {
          variantsToDissociate: productId,
        },
      },
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };

  const handleDeleteProfile = () => {
    DeleteProfileMutation({
      profileId: "gid://shopify/DeliveryProfile/" + id,
    });
  };
  React.useEffect(() => {
    if (updateProfileProductsMutationResult.isSuccess) {
      setOpenProducts(false);
      if (id) {
        profileItemsMutation({
          profileId: id,
        });
      }
    }
  }, [updateProfileProductsMutationResult]);

  React.useEffect(() => {
    if (data) {
      setCountries(data.entityList ?? []);
    }
  }, [data]);

  React.useEffect(() => {
    console.log("Selected Products", selectedProducts);
  }, [selectedProducts]);

  React.useEffect(() => {
    if (DeleteProfileMutationResult.data) {
      if (DeleteProfileMutationResult.data.entity !== "") {
        window.location.href = "/ShippingProfile";
      } else {
        setErrorMessage("sorry! We could not delete your profile.");
      }
    }
  }, [DeleteProfileMutationResult]);

  React.useEffect(() => {
    if (updateProfileMutationResult.data) {
      if (updateProfileMutationResult.data.entity !== "") {
        // setCarrier("");
        // setOpenRate(false);
        // setFlatAmount("0");
        // setPercentage("0");
        window.location.reload();
      } else {
        setErrorMessage("Sorry! We could not add your Rates");
      }
    }
  }, [updateProfileMutationResult]);

  const countriesList = (countries: any) => {
    var data = countries.map((c: any) => c.name + " ");
    return data;
  };
  const getAddress = (address: any) => {
    {
      /* {item.node.address?.address1 +
                              "" +
                              ", " +
                              item.node.address?.city +
                              ", " +
                              item.node.address?.province +
                              ", " +
                              item.node.address?.country} */
    }
    var data =
      address.province !== null
        ? address.address1 +
          ", " +
          address?.city +
          ", " +
          address?.province +
          ", " +
          address?.country
        : address.country;
    return data;
  };
  const handleZoneSubmit = () => {
    setZones([
      ...zones,

      {
        name: zoneName,
        countries: countries
          .filter((item) => item.isSelected)
          .map((c) => {
            return {
              code: c.code,
              provinces: c.provinces?.map((p: any) => {
                return { code: p.code };
              }),
              restOfWorld: false,
            };
          }),
        methodDefinitionsToCreate: [],
      },
    ]);
    setOpenZone(false);
    setZoneName("");
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  React.useEffect(() => {
    if (id) {
      profileDataMutation({
        profileId: id,
      });
      profileLocationMutation({
        profileId: id,
      });
    }
  }, []);

  React.useEffect(() => {
    if (profileLocationMutationResult.isSuccess) {
      if (id) {
        profileItemsMutation({
          profileId: id,
        });
      }
    }
  }, [profileLocationMutationResult]);

  React.useEffect(() => {
    if (profileDataMutationResult.data) {
      var data = JSON.parse(profileDataMutationResult.data.entity);
      console.log("Profile Data", data);
      if (data !== null) {
        setProfile(data);
      }
    }
  }, [profileDataMutationResult]);

  React.useEffect(() => {
    if (profileItemsMutationResult.data) {
      var data = JSON.parse(profileItemsMutationResult.data.entity);
      console.log("Profile Items", data);
      if (data !== null) {
        setProfileItemGroups(data.deliveryProfile.profileItems);
        setProducts(data.deliveryProfile.profileItems.edges);
      }
    }
  }, [profileItemsMutationResult]);

  React.useEffect(() => {
    if (profileLocationMutationResult.data) {
      var data = JSON.parse(profileLocationMutationResult.data.entity);
      console.log("Profile Location", data);
      if (data !== null) {
        setProfileLocationGroups(data.deliveryProfile.profileLocationGroups);
      }
    }
  }, [profileLocationMutationResult]);
  const columns: GridColDef[] = [
    {
      field: "image",
      headerName: "Image",
      type: "actions",
      align: "center",
      headerAlign: "center",
      width: 120,

      renderCell: (params: GridRenderCellParams) => {
        return (
          <ImageIcon
            sx={{
              color: "#6d7175",
              fontSize: "40px",
              border: "2px solid #c9cccf",
              borderRadius: "0.25rem",
              backgroundColor: "#fafbfb",
            }}
          />
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      width: 600,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.node.product.title,
    },
    {
      field: "actions",
      headerName: "Action",
      align: "right",
      headerAlign: "right",
      type: "actions",
      width: 300,

      renderCell: (params: GridRenderCellParams) => {
        return (
          <IconButton
            disabled={updateProfileProductsMutationResult.isLoading}
            onClick={(e) => {
              console.log(
                "removed product",
                params.row?.node.variants.edges[0].node.id
              );
              handleRemoveProducts(params.row?.node.variants.edges[0].node.id);
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        );
      },
    },
  ];

  React.useEffect(() => {}, [profileDataMutationResult]);
  return (
    <>
      {/* <PageLoader isLoading={profileDataMutationResult.isLoading}></PageLoader> */}

      <Container maxWidth="xl">
        <Typography variant="h6" textAlign="left" fontWeight={600} gutterBottom>
          {profile?.deliveryProfile.name}
        </Typography>

        <Card sx={{ borderRadius: 3, mt: 5 }}>
          <CardContent sx={{ minHeight: "30vh" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 550,
                  m: 2,
                }}
              >
                Products
              </Typography>
              <Typography
                textAlign="right"
                sx={{
                  fontSize: "0.875rem",
                  color: "#2c6ecb",
                  cursor: "pointer",
                  m: 2,
                }}
                onClick={() => {
                  setOpenProducts(true);
                }}
              >
                Manage Products
              </Typography>
            </Box>
            <Divider sx={{ borderBottomWidth: 1, mt: 2, mb: 2 }} />
            {profileItemGroups !== null &&
            profileItemGroups.edges.length > 0 ? (
              <>
                <AppGrid
                  data={products.map((item, index) => ({ id: index, ...item }))}
                  columns={columns}
                  isLoading={profileItemsMutationResult.isLoading}
                  checkBox={true} //It will not let to render checkBox selection
                ></AppGrid>
              </>
            ) : (
              <>
                <Typography mt="5vh" textAlign="center">
                  No products
                </Typography>
                <Typography textAlign="center" color="#6d7175">
                  Move products here from another profile to set up separate
                  rates.
                </Typography>
              </>
            )}
          </CardContent>
        </Card>

        <Card sx={{ borderRadius: 3, mt: 5 }}>
          <CardContent sx={{ minHeight: "60vh" }}>
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              Shipping origins
            </Typography>
            <Typography
              sx={{
                fontSize: "0.875rem",
                color: "#6d7175",
              }}
            >
              Choose where you ship and how much you charge for shipping at
              checkout.
            </Typography>
            {profileLocationGroups !== null ? (
              profileLocationGroups[0]?.locationGroup?.locations?.edges.map(
                (item: any) => (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 5,
                    }}
                  >
                    <Box display="flex" flexDirection="row">
                      <LocationOnIcon
                        sx={{
                          color: "#6d7175",
                          fontSize: "40px",
                          border: "2px solid #c9cccf",
                          borderRadius: "0.25rem",
                          backgroundColor: "#fafbfb",
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 550,
                          ml: 2,
                        }}
                      >
                        {item.node.name}
                        <br />
                        <Typography
                          fontSize="0.875rem"
                          fontWeight={400}
                          color="#6d7175"
                        >
                          {getAddress(item.node.address)}
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>
                )
              )
            ) : profileLocationMutationResult.isLoading ? (
              <CircularProgress
                sx={{ ml: "50%", mt: 7 }}
                size="2rem"
                color="inherit"
              />
            ) : (
              ""
            )}

            <Divider sx={{ borderBottomWidth: 1, mt: 2, mb: 2 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 550,
                }}
              >
                Shipping zones
              </Typography>
              <Typography
                textAlign="right"
                sx={{
                  fontSize: "0.875rem",
                  color: "#2c6ecb",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpenZone(true);
                }}
              >
                Create zone
              </Typography>
            </Box>
            {zones.length !== 0
              ? zones.map((item) => {
                  return (
                    <Card sx={{ width: "100%", minHeight: "30vh", mt: 3 }}>
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          <LanguageIcon /> {item.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {item.countries?.map(
                            (country: any) => country.code + " ,"
                          )}
                        </Typography>
                        <br />

                        {item?.methodDefinitionsToCreate.length > 0 ? (
                          <TableContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Carrier Name</TableCell>
                                  <TableCell align="center">
                                    Handling Fee
                                  </TableCell>
                                  <TableCell align="center">
                                    Transit time
                                  </TableCell>
                                  <TableCell align="right" />
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item?.methodDefinitionsToCreate.map(
                                  (row: any) => (
                                    <TableRow
                                      sx={{
                                        "& > *": { borderBottom: "unset" },
                                      }}
                                    >
                                      <TableCell component="th" scope="row">
                                        {row.name}
                                      </TableCell>
                                      <TableCell align="center">
                                        {parseInt(
                                          row.participant?.fixedFee.amount
                                        ) > 0
                                          ? "$ " +
                                            row.participant.fixedFee.amount +
                                            (row.participant
                                              ?.percentageOfRateFee > 0
                                              ? "+ " +
                                                row.participant
                                                  ?.percentageOfRateFee +
                                                "%"
                                              : "")
                                          : row.participant
                                              ?.percentageOfRateFee + "%"}
                                      </TableCell>
                                      <TableCell align="center">
                                        Calculated
                                      </TableCell>

                                      <TableCell align="right">
                                        <div>
                                          <IconButton
                                            id="basic-button"
                                            aria-controls={
                                              open ? "basic-menu" : undefined
                                            }
                                            aria-haspopup="true"
                                            aria-expanded={
                                              open ? "true" : undefined
                                            }
                                            onClick={(e) => {
                                              handleClick(e);
                                            }}
                                          >
                                            <MoreHorizIcon />
                                          </IconButton>
                                          <Menu
                                            id="basic-menu"
                                            anchorEl={anchorE}
                                            open={open}
                                            onClose={handleClose}
                                          >
                                            <MenuItem
                                              onClick={() => {
                                                handleClose();
                                                setSelectedZone(item.name);
                                                handleRemoveRate(row.name);
                                              }}
                                            >
                                              <ListItemText
                                                sx={{ color: "red" }}
                                              >
                                                Delete Rate
                                              </ListItemText>
                                            </MenuItem>
                                          </Menu>
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          <Alert severity="warning">
                            No rates. Customers in this zone won't be able to
                            complete checkout.
                          </Alert>
                        )}
                      </CardContent>
                      <CardActions>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Button
                            size="small"
                            onClick={() => {
                              setOpenRate(true);
                              setSelectedZone(item.name);
                            }}
                          >
                            Add Rate
                          </Button>
                          {updateProfileMutationResult.isLoading ? (
                            <Button
                              disabled
                              size="small"
                              startIcon={
                                <CircularProgress
                                  size="1.2rem"
                                  color="inherit"
                                />
                              }
                            >
                              Save Changes
                            </Button>
                          ) : (
                            <Button
                              size="small"
                              onClick={() => {
                                handleUpdateProfile();
                              }}
                            >
                              Save Changes
                            </Button>
                          )}
                        </Box>
                      </CardActions>
                    </Card>
                  );
                })
              : ""}
            {profileLocationGroups !== null ? (
              profileLocationGroups[0]?.locationGroupZones.edges.length > 0 ? (
                profileLocationGroups[0]?.locationGroupZones.edges.map(
                  (item: any) => (
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: 5,
                          ml: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 550,
                          }}
                        >
                          {item.node.zone.name} <br />
                          <Typography fontSize="0.875rem" fontWeight={400}>
                            {expanded
                              ? countriesList(item.node.zone.countries)
                              : `${countriesList(
                                  item.node.zone.countries
                                ).slice(0, 7)}...`}
                            <Collapse
                              sx={{
                                display:
                                  item.node.zone.countries.length > 7
                                    ? "block"
                                    : "none",
                              }}
                              component="span"
                              collapsedSize={30}
                              in={!expanded}
                            >
                              <Button size="small" onClick={handleExpandClick}>
                                {expanded ? "See less" : "See more"}
                              </Button>
                            </Collapse>
                          </Typography>
                        </Typography>
                        <div>
                          <IconButton
                            id="basic-button"
                            aria-controls={
                              openZoneTip ? "basic-menu" : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={openZoneTip ? "true" : undefined}
                            onClick={(e) => {
                              handleClickZone(e);
                            }}
                          >
                            <MoreHorizIcon />
                          </IconButton>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={openZoneTip}
                            // onClose={}
                            onClose={handleClose}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                          >
                            <MenuItem
                              onClick={() => {
                                handleClose();
                                handleDeleteZone(item.node.zone.id);
                              }}
                            >
                              <ListItemText sx={{ color: "red" }}>
                                Delete
                              </ListItemText>
                            </MenuItem>
                          </Menu>
                        </div>
                      </Box>
                      {item.node?.rateDefinitions?.edges.length > 0 ? (
                        <TableContainer>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Rate Name</TableCell>
                                <TableCell align="center">Condition</TableCell>
                                <TableCell align="center">
                                  Transit time
                                </TableCell>
                                <TableCell align="center">Price</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {item.node?.rateDefinitions?.edges.map(
                                (row: any) => (
                                  <TableRow
                                    sx={{
                                      "& > *": { borderBottom: "unset" },
                                    }}
                                  >
                                    <TableCell component="th" scope="row">
                                      {row.node.name}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row.node?.methodConditions.length > 1
                                        ? row.node?.methodConditions[0]
                                            ?.conditionCriteria.__typename ===
                                          "Weight"
                                          ? row.node.methodConditions[0]
                                              ?.conditionCriteria.value +
                                            "lb--" +
                                            row.node.methodConditions[1]
                                              ?.conditionCriteria.value +
                                            "lb"
                                          : "$" +
                                            row.node.methodConditions[0]
                                              ?.conditionCriteria.amount +
                                            "$" +
                                            row.node.methodConditions[0]
                                              ?.conditionCriteria.amount
                                        : row.node.methodConditions[0]
                                            ?.conditionCriteria.__typename ===
                                          "Weight"
                                        ? row.node.methodConditions[0]
                                            .operator ===
                                          "LESS_THAN_OR_EQUAL_TO"
                                          ? "0lb--" +
                                            row.node.methodConditions[0]
                                              ?.conditionCriteria.value +
                                            "lb"
                                          : row.node.methodConditions[0]
                                              ?.conditionCriteria.value +
                                            "lb--" +
                                            "and up"
                                        : row.node.methodConditions[0]
                                            ?.condition ===
                                          "LESS_THAN_OR_EQUAL_TO"
                                        ? "$0--" +
                                          "$" +
                                          row.node.methodConditions[0]
                                            ?.conditionCriteria.amount
                                        : "$" +
                                          row.node.methodConditions[0]
                                            ?.conditionCriteria.amount +
                                          "and up"}
                                    </TableCell>
                                    <TableCell align="center">
                                      Calculated
                                    </TableCell>
                                    <TableCell align="center">
                                      {"$" +
                                        row.node?.rateProvider.price.amount}
                                    </TableCell>
                                    {/* <TableCell align="right">
                                        <div>
                                          <IconButton
                                            id="basic-button"
                                            aria-controls={
                                              open ? "basic-menu" : undefined
                                            }
                                            aria-haspopup="true"
                                            aria-expanded={
                                              open ? "true" : undefined
                                            }
                                            onClick={(e) => {
                                              handleClick(e);
                                            }}
                                          >
                                            <MoreHorizIcon />
                                          </IconButton>
                                          <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            // onClose={}
                                            onClose={handleClose}
                                            MenuListProps={{
                                              "aria-labelledby": "basic-button",
                                            }}
                                          >
                                            <MenuItem
                                              onClick={() => {
                                                //navigate(`/ProductDetail/${selectedRow?.id}`);
                                              }}
                                              // LinkComponent={() => <Link to={`/Detail/${selectedRow?.id}`} />}
                                            >
                                              <ListItemText>
                                                Edit Zone
                                              </ListItemText>
                                            </MenuItem>
                                            <MenuItem
                                              onClick={() => {
                                                handleClose();
                                                // setDeleteConfirm(true);
                                              }}
                                            >
                                              <ListItemText
                                                sx={{ color: "red" }}
                                              >
                                                Delete
                                              </ListItemText>
                                            </MenuItem>
                                          </Menu>
                                        </div>
                                      </TableCell> */}
                                  </TableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        ""
                      )}

                      {item.node.participantDefinitions.edges.length > 0 ? (
                        <TableContainer>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Carrier Name</TableCell>
                                <TableCell align="center">
                                  Handling Fee
                                </TableCell>
                                <TableCell align="center">
                                  Transit time
                                </TableCell>
                                <TableCell align="right" />
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {item.node.participantDefinitions.edges.map(
                                (row: any) => (
                                  <TableRow
                                    sx={{
                                      "& > *": { borderBottom: "unset" },
                                    }}
                                  >
                                    <TableCell component="th" scope="row">
                                      {
                                        row.node.rateProvider.carrierService
                                          .formattedName
                                      }
                                    </TableCell>
                                    <TableCell align="center">
                                      {parseInt(
                                        row.node.rateProvider.fixedFee.amount
                                      ) > 0
                                        ? "$ " +
                                          row.node.rateProvider.fixedFee
                                            .amount +
                                          (row.node.rateProvider
                                            .percentageOfRateFee > 0
                                            ? "+ " +
                                              row.node.rateProvider
                                                .percentageOfRateFee +
                                              "%"
                                            : "")
                                        : row.node.rateProvider
                                            .percentageOfRateFee + "%"}
                                    </TableCell>
                                    <TableCell align="center">
                                      Calculated
                                    </TableCell>

                                    <TableCell align="right">
                                      <div>
                                        <IconButton
                                          id="basic-button"
                                          aria-controls={
                                            openRateTip
                                              ? "basic-menu"
                                              : undefined
                                          }
                                          aria-haspopup="true"
                                          aria-expanded={
                                            openRateTip ? "true" : undefined
                                          }
                                          onClick={(e) => {
                                            handleClickRate(e);
                                          }}
                                        >
                                          <MoreHorizIcon />
                                        </IconButton>
                                        <Menu
                                          id="basic-menu"
                                          anchorEl={anchorE2}
                                          open={openRateTip}
                                          onClose={handleClose}
                                          MenuListProps={{
                                            "aria-labelledby": "basic-button",
                                          }}
                                        >
                                          <MenuItem
                                            onClick={() => {
                                              handleClose();
                                              handleDeleteRate(
                                                row.node.id,
                                                item.node.zone.id
                                              );
                                            }}
                                          >
                                            <ListItemText sx={{ color: "red" }}>
                                              Delete Rate
                                            </ListItemText>
                                          </MenuItem>
                                        </Menu>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ mt: 2 }}
                            onClick={() => {
                              setOpenRate(true);
                              setOnlyRate(true);
                              setSelectedZoneId(item.node.zone.id);
                            }}
                          >
                            Add Rate
                          </Button>
                        </TableContainer>
                      ) : (
                        <Button
                          size="small"
                          variant="outlined"
                          sx={{ mt: 2 }}
                          onClick={() => {
                            setOpenRate(true);
                            setOnlyRate(true);
                            setSelectedZoneId(item.node.zone.id);
                          }}
                        >
                          Add Rate
                        </Button>
                      )}
                    </Box>
                  )
                )
              ) : (
                ""
              )
            ) : profileLocationMutationResult.isLoading ? (
              <CircularProgress
                sx={{ ml: "50%", mt: 7 }}
                size="2rem"
                color="inherit"
              />
            ) : (
              ""
            )}
          </CardContent>
        </Card>

        <Card sx={{ borderRadius: 3, mt: 5 }}>
          <CardContent sx={{ minHeight: "20vh" }}>
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              Not shipping from
            </Typography>
            <Typography
              sx={{
                fontSize: "0.875rem",
                color: "#6d7175",
              }}
            >
              Shipping options will not appear at checkout on orders fulfilled
              from these locations. Add rates to activate these locations.
            </Typography>
            {profile !== null ? (
              profile?.deliveryProfile.unassignedLocations.nodes.map(
                (item: any) => (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 5,
                    }}
                  >
                    <Box display="flex" flexDirection="row">
                      <LocationOnIcon
                        sx={{
                          color: "#6d7175",
                          fontSize: "40px",
                          border: "2px solid #c9cccf",
                          borderRadius: "0.25rem",
                          backgroundColor: "#fafbfb",
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 550,
                          ml: 2,
                        }}
                      >
                        {item.name}
                        <br />
                        <Typography
                          fontSize="0.875rem"
                          fontWeight={400}
                          color="#6d7175"
                        >
                          {getAddress(item.address)}
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>
                )
              )
            ) : profileDataMutationResult.isLoading ? (
              <CircularProgress
                sx={{ ml: "50%", mt: 7 }}
                size="2rem"
                color="inherit"
              />
            ) : (
              ""
            )}
          </CardContent>
        </Card>

        <Button
          size="small"
          variant="outlined"
          sx={{
            mt: 2,
            mb: 4,
            backgroundColor: "#d82c0d",
            color: "white",
            "&.MuiButtonBase-root:hover": {
              bgcolor: "#d82c0d",
            },
            textTransform: "none",
          }}
          onClick={() => {
            setDeleteConfirm(true);
          }}
        >
          Delete Profile
        </Button>

        <Dialog
          open={openRate}
          onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          fullWidth
        >
          <DialogTitle sx={{ textAlign: "center" }}>Add Rate</DialogTitle>
          <DialogContent>
            <FormControl sx={{ mt: 4 }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Carrier
              </InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={carrier}
                label="Select Carrier"
                onChange={(e) => {
                  //setCarrier(e.target.value);
                  handleSetCarrier(e.target.value);
                }}
              >
                {carriers.map((item) => (
                  <MenuItem value={item.name}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Divider sx={{ mt: 4 }} />
            <Typography variant="subtitle2" sx={{ mt: 3 }}>
              SERVICES
            </Typography>
            <Typography sx={{ mt: 1, fontSize: "0.8em", color: "#6d7175" }}>
              Rates are based on your customer’s address and the weight and
              dimensions of their order.
            </Typography>
            {services.length > 0
              ? services.map((service) => (
                  <MenuItem key={service.service} value={service.service}>
                    <Checkbox
                      checked={service.isSelected}
                      onChange={() => onServiceClick(service.service)}
                    />
                    <ListItemText primary={service.service} />
                  </MenuItem>
                ))
              : ""}
            <Divider />
            <Typography variant="subtitle2" sx={{ mt: 3 }}>
              HANDLING FEE
            </Typography>
            <Typography sx={{ mt: 1, fontSize: "0.8em", color: "#6d7175" }}>
              Adjust calculated rates to account for packaging and handling
              costs.
            </Typography>
            <Grid
              container
              spacing={2}
              sx={{ mt: 1.5 }}
              justifyContent="space-between"
            >
              <Grid item xs={6}>
                {" "}
                <TextField
                  variant="outlined"
                  name="percenatge"
                  label="Percenatge"
                  fullWidth
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  value={percentage}
                  onChange={(e: any) => {
                    setPercentage(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                {" "}
                <TextField
                  variant="outlined"
                  name="flatAmount"
                  label="Flat Amount"
                  fullWidth
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  value={flatAmount}
                  onChange={(e: any) => {
                    setFlatAmount(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Typography mr="10%" color="red">
              {errorMessage}
            </Typography>
            <Button autoFocus onClick={handleClose}>
              Cancel
            </Button>
            {updateProfileMutationResult.isLoading ? (
              <Button
                disabled
                startIcon={<CircularProgress size="1.2rem" color="inherit" />}
              >
                Apply
              </Button>
            ) : (
              <Button
                disabled={carrier.length === 0}
                onClick={onlyRate ? handleUpdateRates : handleRateSubmit}
              >
                Apply
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          open={openZone}
          onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          fullWidth
        >
          <DialogTitle sx={{ textAlign: "center" }}>Create Zone</DialogTitle>
          <DialogContent>
            <TextField
              variant="outlined"
              name="zoneName"
              label="Zone Name"
              fullWidth
              size="small"
              sx={{ mt: 2 }}
              required
              value={zoneName}
              onChange={(e: any) => {
                setZoneName(e.target.value);
              }}
            />

            <br />
            <br />

            <TextField
              variant="outlined"
              name="countries"
              label="Search Countries"
              fullWidth
              size="small"
              required
              value={searchQuery}
              onChange={(e: any) => {
                setSearchQuery(e.target.value);
              }}
            />
            <br />
            <br />
            <div style={{ maxHeight: "350px", overflowY: "auto" }}>
              {countries
                .filter(
                  (item) =>
                    item.name
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase()) ||
                    item.provinces?.some((prov: any) =>
                      prov.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    )
                )
                .map((item, index) => (
                  <React.Fragment key={index}>
                    <MenuItem key={item.id} value={item.id}>
                      <Checkbox
                        checked={item.isSelected}
                        onChange={() => onCountryClick(item, index)}
                        indeterminate={
                          item.isSelected &&
                          item.provinces?.some((n) => !n.isSelected)
                        }
                      />

                      <ListItemText
                        primary={item.name}
                        sx={{ paddingLeft: "10px" }}
                      />
                    </MenuItem>
                    {item.provinces
                      ?.filter((prov: any) =>
                        prov.name
                          .toLowerCase()
                          .includes(searchQuery.toLowerCase())
                      )
                      .map((province: any) => {
                        return (
                          <>
                            <MenuItem
                              key={province.id}
                              value={province.id}
                              style={{ marginLeft: 25 }}
                            >
                              <Checkbox
                                checked={province.isSelected}
                                onChange={() => {
                                  onProvinceClick(province);
                                }}
                              />

                              <ListItemText primary={province.name} />
                            </MenuItem>
                          </>
                        );
                      })}
                  </React.Fragment>
                ))}
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Cancel
            </Button>
            <Button
              disabled={zoneName === "" ? true : false}
              onClick={handleZoneSubmit}
            >
              Apply
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openProducts} onClose={handleClose} maxWidth="lg">
          <DialogTitle sx={{ textAlign: "center" }}>
            Select Products
          </DialogTitle>
          <DialogContent>
            <ManageShippingProducts setSelectedProducts={setSelectedProducts} />
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Button autoFocus onClick={handleClose}>
                Cancel
              </Button>
              {updateProfileProductsMutationResult.isLoading ? (
                <Button
                  disabled
                  startIcon={<CircularProgress size="1.2rem" color="inherit" />}
                >
                  Save
                </Button>
              ) : (
                <Button onClick={handleAddProducts}>Save</Button>
              )}
            </Box>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteConfirm}
          onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ fontWeight: 600, textAlign: "center" }}>
            Delete profile
          </DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this profile? All products from
              this profile will show rates from your general profile at
              checkout.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Typography mr="10%" color="red">
              {errorMessage}
            </Typography>
            <Button
              autoFocus
              onClick={() => {
                setDeleteConfirm(false);
              }}
            >
              Cancel
            </Button>

            {DeleteProfileMutationResult.isLoading ? (
              <Button
                size="small"
                variant="outlined"
                disabled
                sx={{ color: "red" }}
                startIcon={<CircularProgress size="1.2rem" color="inherit" />}
              >
                Deleting
              </Button>
            ) : (
              <Button
                size="small"
                variant="outlined"
                sx={{
                  backgroundColor: "#d82c0d",
                  color: "white",
                  "&.MuiButtonBase-root:hover": {
                    bgcolor: "#d82c0d",
                  },
                }}
                onClick={handleDeleteProfile}
              >
                Delete
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default DeliveryProfileDetail;
